export function setProductParentList(state, payload) {
    state.productParentList = payload;
}

export function setProductParentItem(state, payload) {
    state.productParentItem = payload;
}

export function setProductParentByPage(state, payload) {
    state.pagination = payload;
}

export function setImagesColor(state, payload) {
    state.imagesColor = payload;
}

export function setDataSheetsLineArr(state, payload) {
    state.dataSheetsLineArr = payload;
}


// WEBPACK FOOTER //
// ./src/modules/product-parent/mutations.js